<template>
    <div class="main">
        <c-panel :title="titulo" titleIcon="fas fa-robot">
            <atendimento></atendimento>
        </c-panel>
    </div>
</template>
<script>
import atendimento from "./atendimento"
export default {
    components: { atendimento },
    data () { return { titulo: '' } },
    created () { this.titulo = (this.$route.meta && this.$route.meta.title) || 'Assistente Virtual' }
}
</script>
